
export class BaseClientService {

}
